import { getCsrfToken } from 'query';
import { REVIEW_CRITERIA, REVIEW_DETAILS, tokenizeRoute } from 'query/routes';

/**
 * Get the current review id by scraping the URL
 *
 * TODO: find a better way of doing this, along with getStudyId
 */
export const getReviewId = () => {
  const tokens = window.location.pathname.split('/');
  const index = tokens.indexOf('reviews');

  if (index >= 0 && index < tokens.length - 1) {
    return tokens[index + 1];
  }
  return null;
};

// Named to avoid colliding with the unrelated UpdateResponseBody exported
// from query/review/DataExtractionTemplate (both re-exported via the
// query/review barrel).
export type ReviewUpdateResponseBody = {
  errors?: Record<string, string[]>;
};

// pageOptions.page selects both the route and, server-side, which calling
// context reviews#update treats this as: 'details' for Review Settings,
// anything else (e.g. 'criteria') for Eligibility Criteria.
export const saveReviewData = async (
  data: any,
  pageOptions: Record<string, unknown>
): Promise<{ success: boolean; body: ReviewUpdateResponseBody }> => {
  const reviewId = getReviewId();
  const route =
    pageOptions.page === 'details' ? REVIEW_DETAILS : REVIEW_CRITERIA;
  const url = tokenizeRoute(route, {
    review_id: reviewId,
  });

  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ review: data, ...pageOptions }),
  }).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      // All good, carry on
      return { success: true, body: {} };
    }
    return response.json().then((json) => {
      // parse the JSON body so we can do things with it
      return { success: false, body: json as ReviewUpdateResponseBody };
    });
  });
};
